import get from 'lodash.get';

const getSettingByName = (settings, name, defaultValue = null) => get(settings, name, defaultValue);

export default getSettingByName;
